import React from "react";
import SettingsPage from "../partners/settings/SettingsPage";

export default function Settings({partner}) {
  
  return (
    <>
      <SettingsPage />
    </>
  );
}